import company from './company'
import department from './department'
import industry from './industry'
import salary from './salary'
import experience from './experience'
import education from './education'

export default {
  [company.name]: company,
  [department.name]: department,
  [industry.name]: industry,
  [salary.name]: salary,
  [experience.name]: experience,
  [education.name]: education
}
